import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./SecurityOneHostHome.scss";
import { useCollection } from "../../../../firebase-files/hooks/useCollection";
// import { timestamp } from "../../../../firebase-config/config";
const SecurityOneHostHome = () => {
  const navigate = useNavigate();

  const { documents: visitorsDocuments } = useCollection("visitors");
  const { documents: userDocuments } = useCollection("users");

  const [visitorsData, setVisitorsData] = useState([]);

  useEffect(() => {
    if (visitorsDocuments) {
      setVisitorsData(visitorsDocuments);
    }
  }, [visitorsDocuments]);

  if (!visitorsDocuments) {
    return <div className="loading"></div>;
  }

  return (
    <div className="security-one-host-home">
      <div className="security-one-host-home-visits-summary">
        <div className="security-one-host-home-visits-summary-card">
          <h2>Your Visitors</h2>
          <div className="security-one-host-home-visits-summary-card-visit-count">
            {visitorsData.length}
          </div>
        </div>
      </div>

      <div className="security-one-host-home-visitors-section">
        <div className="visitors-grid">
          {visitorsData &&
            visitorsData.map((visitor) => {
              // Match user by phone number
              const matchedUser = userDocuments?.find(
                (user) => user.phoneNumber === visitor.phoneNumber
              );

              return (
                <div
                  key={visitor.id}
                  className="visitor-card"
                  onClick={() => navigate(`/visitor-details/${visitor.id}`)}
                >
                  <div className="visitor-image d-flex justify-content-between align-items-center">
                    <img
                      src={
                        matchedUser?.registeredFaceUrl ||
                        "/assets/img/men-icon-login.png"
                      }
                      alt={visitor.visitorName}
                    />
                    <div>
                      {/* <p className="visit-date">
                        <span className="icon">📅</span>
                        {new Date(
                          visitor.visitorEntryTimeStamp.toDate()
                        ).toLocaleDateString()}
                      </p> */}
                      <p className="visit-time">
                        <h6>
                          <span className="icon">🙍‍♂️</span>
                          {visitor.visitorName}
                        </h6>

                        <span className="icon">🕒</span>
                        {visitor.visitorEntryTimeStamp === null
                          ? ""
                          : new Date(
                              visitor.visitorEntryTimeStamp.toDate()
                            ).toLocaleTimeString()}
                      </p>
                    </div>
                  </div>
                  <div className="visitor-info">
                    <div className="visit-time-details">
                      <p className="visit-date">
                        <span className="icon">📅Entry:</span>
                        {visitor.visitorEntryTimeStamp ? (
                          (() => {
                            const dateObj = new Date(
                              visitor.visitorEntryTimeStamp.toDate()
                            );
                            const date = `${dateObj.getDate()}-${
                              dateObj.getMonth() + 1
                            }-${dateObj.getFullYear()}`;
                            const time = dateObj.toLocaleTimeString();
                            return `${date}, ${time}`;
                          })()
                        ) : (
                          <span style={{ color: "gray", fontStyle: "italic" }}>
                            Entry time not recorded yet
                          </span>
                        )}
                      </p>

                      <p className="visit-time">
                        <span className="icon">🕒Exit: </span>
                        {visitor.visitorExitTimeStamp ? (
                          (() => {
                            const dateObj = new Date(
                              visitor.visitorExitTimeStamp.toDate()
                            );
                            const date = `${dateObj.getDate()}-${
                              dateObj.getMonth() + 1
                            }-${dateObj.getFullYear()}`;
                            const time = dateObj.toLocaleTimeString();
                            return `${date}, ${time}`;
                          })()
                        ) : (
                          <span style={{ color: "gray", fontStyle: "italic" }}>
                            Exit time not recorded yet
                          </span>
                        )}
                      </p>
                    </div>

                    <span className="purpose">Remarks - {visitor.remarks}</span>
                  </div>
                </div>
              );
            })}
        </div>
      </div>

      <div className="security-one-host-home-pre-approve-add-btn">
        <button onClick={() => navigate("/host-pre-approve")}>+</button>
      </div>
    </div>
  );
};

export default SecurityOneHostHome;
